var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FieldQuantityItem {
    constructor(elem) {
        this.minus = null;
        this.plus = null;
        this.input = null;
        this.minimum = 0;
        this.interval = null;
        this.intervalDelay = null;
        // Time to trigger increment or decrement value when press holding the plus and minus buttons
        this.intervalTimeout = 140;
        this.intervalDelayTimeout = 300;
        this.eventTimeout = null;
        this.originalValue = null;
        // Time to wait before triggering the field-quantity-update event to the window.
        this.eventTimeouttime = 500;
        this.reset = () => {
            this.input.value = this.originalValue;
            this.checkIfEnabled();
        };
        this.cancelTimeout = () => __awaiter(this, void 0, void 0, function* () {
            if (this.intervalDelay) {
                clearTimeout(this.intervalDelay);
            }
            if (this.eventTimeout) {
                yield clearTimeout(this.eventTimeout);
            }
        });
        this.input = elem.querySelector('input');
        this.minus = elem.querySelector('.field-quantity__minus');
        this.plus = elem.querySelector('.field-quantity__plus');
        this.minimum = parseInt(this.input.getAttribute('min'), 10);
        this.originalValue = this.input.value;
        this.inputChanged = this.inputChanged.bind(this);
        this.increaseIntervalStart = this.increaseIntervalStart.bind(this);
        this.decreaseIntervalStart = this.decreaseIntervalStart.bind(this);
        this.stopEvents = this.stopEvents.bind(this);
        this.reset = this.reset.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBlur = this.onBlur.bind(this);
        if ('ontouchstart' in document.documentElement) {
            this.mouseEvent = 'touchend';
        }
        else {
            this.mouseEvent = 'mouseup';
        }
    }
    init() {
        this.input.addEventListener('change', this.inputChanged);
        this.input.addEventListener('keydown', this.onlyNumbers);
        this.input.addEventListener('keyup', this.onKeyUp);
        this.input.addEventListener('blur', this.onBlur);
        this.checkIfEnabled();
        if ('ontouchstart' in document.documentElement) {
            this.minus.addEventListener('touchstart', this.decreaseIntervalStart);
            this.plus.addEventListener('touchstart', this.increaseIntervalStart);
        }
        else {
            this.minus.addEventListener('mousedown', this.decreaseIntervalStart);
            this.plus.addEventListener('mousedown', this.increaseIntervalStart);
        }
        return this;
    }
    onBlur(e) {
        if (!this.input.value || this.input.value <= 0) {
            this.input.value = 1;
        }
    }
    onKeyUp(e) {
        window.dispatchEvent(new CustomEvent('field-quantity-keyup', {
            detail: {
                element: this.input,
                value: this.input.value,
                reset: this.reset,
            },
        }));
    }
    onlyNumbers(e) {
        if (e.key === 'e' || e.key === '-' || e.key === '+' || e.key === '.' || e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    }
    getValue() {
        return parseInt(this.input.value, 10);
    }
    checkIfEnabled() {
        if (this.getValue() === this.minimum) {
            this.minus.setAttribute('disabled', 'disabled');
        }
        else {
            this.minus.removeAttribute('disabled');
        }
    }
    inputChanged() {
        this.checkIfEnabled();
        if (this.getValue() <= this.minimum) {
            this.input.value = this.minimum;
            this.stopEvents();
        }
        else {
            this.dispatchChangeEvent();
        }
        this.dispatchValueChange();
    }
    addDocumentListener() {
        this.cancelTimeout();
        this.removeDocumentListener();
        document.addEventListener(this.mouseEvent, this.stopEvents, true);
    }
    removeDocumentListener() {
        document.removeEventListener(this.mouseEvent, this.stopEvents, true);
    }
    stopEvents() {
        this.removeDocumentListener();
        this.cancelInterval();
        this.dispatchChangeEvent();
    }
    dispatchChangeEvent() {
        this.cancelTimeout();
        const time = this.eventTimeouttime;
        this.eventTimeout = setTimeout(() => {
            window.dispatchEvent(new CustomEvent('field-quantity-updated', {
                detail: {
                    element: this.input,
                    value: this.input.value,
                    reset: this.reset,
                },
            }));
        }, time);
    }
    dispatchValueChange() {
        window.dispatchEvent(new CustomEvent('field-quantity-value-change', {
            detail: {
                value: this.input.value,
            },
        }));
    }
    disable() {
        this.plus.setAttribute('disabled', 'disabled');
        this.minus.setAttribute('disabled', 'disabled');
        this.input.setAttribute('disabled', 'disabled');
    }
    enable() {
        this.plus.removeAttribute('disabled', 'disabled');
        this.input.removeAttribute('disabled');
        this.checkIfEnabled();
    }
    cancelInterval() {
        this.cancelTimeout();
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    increaseIntervalStart(event) {
        this.addDocumentListener();
        this.cancelInterval();
        this.increaseNumber();
        const time = this.intervalTimeout;
        if ('mousedown' === event.type) {
            this.interval = setInterval((() => {
                this.increaseNumber();
            }).bind(this), time);
        }
        else {
            const intervalDelayTimeout = this.intervalDelayTimeout;
            clearTimeout(this.intervalDelay);
            this.intervalDelay = setTimeout((() => {
                this.interval = setInterval((() => {
                    this.increaseNumber();
                }).bind(this), time);
            }).bind(this), intervalDelayTimeout);
        }
    }
    decreaseIntervalStart() {
        this.addDocumentListener();
        this.cancelInterval();
        this.decreaseNumber();
        const time = this.intervalTimeout;
        if ('mousedown' === event.type) {
            this.interval = setInterval((() => {
                this.decreaseNumber();
            }).bind(this), time);
        }
        else {
            const intervalDelayTimeout = this.intervalDelayTimeout;
            clearTimeout(this.intervalDelay);
            this.intervalDelay = setTimeout((() => {
                this.interval = setInterval((() => {
                    this.decreaseNumber();
                }).bind(this), time);
            }).bind(this), intervalDelayTimeout);
        }
    }
    increaseNumber() {
        this.input.value = this.getValue() + 1;
        this.checkIfEnabled();
        this.dispatchValueChange();
    }
    decreaseNumber() {
        if (this.getValue() > this.minimum) {
            this.input.value = this.getValue() - 1;
            this.checkIfEnabled();
        }
        if (this.getValue() === this.minimum) {
            this.stopEvents();
        }
        this.dispatchValueChange();
    }
}
const instances = [];
const FieldQuantity = () => {
    const fields = document.querySelectorAll('.field-quantity');
    if (fields.length > 0) {
        [...fields].forEach((field) => {
            const fieldQty = new FieldQuantityItem(field);
            instances.push(fieldQty);
            fieldQty.init();
        });
    }
    return instances;
};
export default FieldQuantity;
